import React from 'react';
import { Card, Badge, Avatar } from '@dopomogai/ui';

// This is the presentational component we need.
// It takes all its data as props and does not fetch anything.
export interface AgentVersionCardProps {
  name: string;
  subtitle: string;
  avatarUrl?: string;
  agentId: string; // The base agent template ID, e.g., 'ecom-concierge-v1'
  tags: string[];
  onClick: () => void;
  className?: string;
}

export const AgentVersionCard: React.FC<AgentVersionCardProps> = ({
  name,
  subtitle,
  avatarUrl,
  agentId,
  tags,
  onClick,
  className,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`h-full ${className || ''}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-label={`Edit version ${name}`}
    >
      <Card noHoverEffect className="h-full">
        <div className="flex flex-col h-full p-5 transition-all hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[4px_4px_0_0_rgb(17,24,39)] border-2 border-transparent hover:border-black rounded-xl">
          <div className="flex items-start gap-4">
            <Avatar src={avatarUrl} initials={name[0]} size="lg" />
            <div className="flex-1 min-w-0">
              <p className="text-lg font-extrabold text-slate-900 truncate" title={name}>{name}</p>
              <p className="text-sm text-slate-600 truncate" title={subtitle}>{subtitle}</p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-1.5">
            <Badge text={agentId} accentColor="blue" />
            {tags.slice(0, 2).map(tag => (
              <Badge key={tag} text={tag} accentColor="gray" />
            ))}
          </div>
          <div className="flex-grow" />
          <div className="mt-4 text-right">
             <span className="text-sm font-semibold text-emerald-600 hover:text-emerald-700">
               Continue building &rarr;
             </span>
          </div>
        </div>
      </Card>
    </div>
  );
};